export default __webpack_public_path__ + "static/Roboto-Regular-9429985be4f46ec8fcfceeae0d720944.woff2";